module.exports = __webpack_public_path__ + "static/img/a083.f94df91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a083.jpg
// module id = 3kuh
// module chunks = 0